import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './core/App.jsx';
import './index.css';
import { register } from './utils/serviceWorkerRegistration';

// 🚀 字體載入檢測與優化
if ('fonts' in document) {
  // 使用 Font Loading API 檢測字體載入狀態
  Promise.all([
    document.fonts.load('400 1em Inter'),
    document.fonts.load('400 1em "Noto Sans TC"'),
    document.fonts.load('400 1em "Noto Serif JP"'),
  ]).then(() => {
    // 字體載入完成後添加類別，觸發字體切換
    document.body.classList.add('fonts-loaded');
  }).catch((error) => {
    console.warn('字體載入失敗，使用備用字體:', error);
    // 即使失敗也添加類別，確保不會一直等待
    document.body.classList.add('fonts-loaded');
  });

  // 設置 3 秒超時，避免字體載入過久影響體驗
  setTimeout(() => {
    if (!document.body.classList.contains('fonts-loaded')) {
      document.body.classList.add('fonts-loaded');
    }
  }, 3000);
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 🚀 延遲註冊 Service Worker，避免阻塞初始渲染
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    register();
  });
} else {
  setTimeout(() => {
    register();
  }, 2000);
}